module.exports = __webpack_public_path__ + "ca8f537f89c6faf49805d3d8fad84ce5.png";